import React, { Component } from 'react'
import Prompt from './Prompt'

export default class R extends Component {
  render() {
    return <Prompt color="blue" letter="R" {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/R.js